import React from "react";
import classes from "./Benifits.module.css";
import Fade from "react-reveal/Fade";

import img1 from "../../Assest/1.png";
import img2 from "../../Assest/2.png";
import img3 from "../../Assest/3.png";
import img4 from "../../Assest/4.png";
import img5 from "../../Assest/5.png";
import img6 from "../../Assest/6.png";

const steps = [
  { img: img1, title: "Expert Guidance", subtitle :"Backed by years of experience and experienced counselers", animation: "left" },
  { img: img2, title: "Personalized Counselling",subtitle :"Get One-On-One counselling tailored to your profile", animation: "left" },
  { img: img3, title: "Equal Support",subtitle :"Every Student gets eual attention, regardless of their rank marks", animation: "right" },

];

const step2 =[

  { img: img4, title: "Timely Updates",subtitle :"Stay Updated with alerts on cutoffs, Counseling date and Documents.", animation: "left" },
  { img: img5, title: "Proven Success",subtitle :"Hundreds of students are placed in top goverment and private colleges",animation: "left" },
  { img: img6, title: "No Hidden Agenda",subtitle :"100% transparent guidance - Putting Studendts First", animation: "right" }  
]
const Benifits = () => {
  return (
    <section className={classes.pros}>
      <h2 className={classes.heading}>WHY CHOOSE RCG</h2>

      <div className={classes.grid}>
        {steps.map((step, index) => (
          <Fade key={index} {...{ [step.animation]: true }}>
            <div className={classes.card}>
              <img src={step.img} alt={step.title} />
              <h3>{step.title}</h3>
              <h4>{step.subtitle}</h4>
              <hr className="aaa"></hr>
            </div>
          </Fade>
        ))}
      </div>
      <div className={classes.grid}>
        {step2.map((step, index) => (
          <Fade key={index} {...{ [step.animation]: true }}>
            <div className={classes.card}>
              <img src={step.img} alt={step.title} />
              <h3>{step.title}</h3>
              <h4>{step.subtitle}</h4>
                  <hr className="aaa"></hr>
            </div>
          </Fade>
        ))}
      </div>

    </section>
  );
};

export default Benifits;
